import { Waves, Wifi, Sofa, GraduationCap, Car, ParkingCircle, Utensils, Snowflake, Tv, ShieldCheck, Dumbbell, Trees, BedDouble, Droplet, Zap, Sparkles, PawPrint, Bike, WashingMachine, Coffee } from "lucide-react";

export const ICONS = {
  waves: Waves, wifi: Wifi, sofa: Sofa, graduation: GraduationCap, car: Car, parking: ParkingCircle,
  utensils: Utensils, snowflake: Snowflake, tv: Tv, shield: ShieldCheck, dumbbell: Dumbbell, trees: Trees,
  bed: BedDouble, droplet: Droplet, zap: Zap, sparkles: Sparkles, paw: PawPrint, bike: Bike,
  washing: WashingMachine, coffee: Coffee,
};

export const ICON_KEYS = Object.keys(ICONS);
